/**
 * Validates a single field in the Physician Details form for ScriptCo.
 * @param {string} name - Field name
 * @param {string} value - Field value
 * @returns {string|null} - Error message or null if valid
 */
export const validatePhysicianField = (name, value) => {
  return null;
};

/**
 * Validates the entire Physician Details form data.
 * @param {object} data - Physician details data
 * @returns {object} - Object containing errors for each field
 */
export const validatePhysicianForm = (data) => {
  return {};
};
